import React from 'react';
import LinkButton from '../../components/Buttons/LinkButton';

function IntershipRequest() {
  return (
    <>
      <h3>Intership Request</h3>
      <LinkButton link='/intership/request-preview' color='primary'
        variant='contained'> Preview
      </LinkButton> 
    </>
  );
}

export default IntershipRequest;